import { observable, action } from 'mobx';
import { getAutomatorConfig, getAutomatorAllConfig, getAutoConfigOrder } from '../../service/index';
import RFBluetoothInstance from '../../native-interact/RFBluetooth';
import { readStore } from './rf';
import { formatDateTime } from '../../js/utils';
import { globalStore } from './global';
import { upgradeStore } from './upgrade';
import { getVersion, setWorkState } from '../../service/command';

// 根据不同运营商获取服务器ip
function getOperatorIp() {
  const { operator } = readStore.projectParam;

  // TODO 统一从配置文件里取
  if (readStore.isNB()) {
    if (operator.value === '中国移动') {
      return '115.231.31.15';
    }
    if (operator.value === '中国电信') {
      return '117.60.157.137';
    }
  }

  return '47.96.170.106';
}

// 替换自动化命令中对应的值
function replaceCommand(cmd) {
  return cmd.replace('##NOW##', `"${formatDateTime(new Date())}"`)
    .replace('##SERVER##', getOperatorIp());
}

export default class AutomatorStore {
  @observable tasks = [];

  @action async getAutoData(pageType = 'index') {
    const detectType = [];
    // 通信类型，用于判断自动化测试命令apply参数是否适用
    const commType = readStore.projectParam.communicateType.value.toLowerCase();

    readStore.getProjParam('detectType').forEach((item) => {
      if (item.value) {
        detectType.push(item.title);
      }
    });
    // console.log(`detectType:${JSON.stringify(detectType)}`)  --->   ['rader', 'geo']

    // 考虑先进入安全模式和调试模式
    // await setWorkState('froz'); // 进入仓储模式
    // await setWorkState('install'); // 进入调试模式

    // 获取CPU1版本号
    // const version = (await getVersion('cpu1')).version.split(' ')[0];
    const version = upgradeStore.version;
    globalStore.version = version;

    // cfg_magbase_en 值
    let cfgMagbaseEnData = await RFBluetoothInstance.sendCommand('prt cfg.magbase_en', {
      name: '获取调试cfg_magbase_en值',
      desc: '获取调试cfg_magbase_en值',
      expect: 'cfg.magbase_en='
    });
    cfgMagbaseEnData = cfgMagbaseEnData.split('\n\r')[0];
    const cfgMagbaseEn = cfgMagbaseEnData.split('=').length > 1 ? cfgMagbaseEnData.split('=')[1] : 0;
    globalStore.cfgMagbaseEn = cfgMagbaseEn;
    console.log(`cfg_magbase_en值: ${cfgMagbaseEn}----cpu1版本号: ${version}`);
    // 如果cfgMagbaseEn == 1 表示去请求版本对应的调试脚本序列 否则调试脚本按照默认顺序执行
    // 调试脚本
    const tasks = [];
    if (cfgMagbaseEn >= 1 || version >= 6.92) {
      const AutomatorConfig = await getAutomatorAllConfig();
      // 版本对应命令序列
      const AutomatorConfigOrder = (await getAutoConfigOrder(version)).commands;
      // console.log(`调试脚本命令序列：${AutomatorConfigOrder}`);
      // 重新组合调试脚本
      const finallArray = [];
      AutomatorConfigOrder.forEach((item) => {
        for (let i = 0; i < AutomatorConfig.length; i++) {
          // 此处跳过调试脚本第三步：获取版本号
          // eslint-disable-next-line eqeqeq
          if (AutomatorConfig[i].id == item && i != 2) {
            finallArray.push(AutomatorConfig[i]);
            break;
          }
        }
      });
      // console.log(`${version}最终调试脚本: ${JSON.stringify(finallArray)}`);
      finallArray.forEach((item) => {
        const needArr = item.apply.split(',');
        const need = (function () {
          if (item.apply === '' || needArr.indexOf(commType) >= 0) return true;
          for (let i = 0; i < detectType.length; i++) {
            if (needArr.indexOf(detectType[i]) >= 0) {
              return true;
            }
          }
          return false;
        }());
        if (need) {
          tasks.push(Object.assign({}, item, {
            status: 'default',
            text: `${item.name}中...`,
            success: `${item.name}完成`,
            error: `${item.name}失败`,
            execute: () => {
              return RFBluetoothInstance.sendCommand(replaceCommand(item.command), item);
            }
          }));
        }
      });
      this.tasks = tasks;
      // console.log(JSON.stringify(tasks));
      return Promise.resolve(this.tasks);
    }

    // 普通地磁按照默认调试脚本执行调试步骤
    // 判断自动化执行命令中apply字段是否包含当前地磁类型，不包含则对应命令不执行
    const AutomatorConfig = await getAutomatorConfig(pageType);
    // console.log(`${version}最终调试脚本: ${JSON.stringify(AutomatorConfig)}`);
    AutomatorConfig.forEach((item) => {
      const needArr = item.apply.split(',');
      // eslint-disable-next-line no-loop-func
      const need = (function () {
        // NOTE 暂时取消标记位的判断，所有地磁都进行初始化雷达
        // if (/^init\s+radar.*/.test(item.command) && !globalStore.isInitRadar) {
        //   return false;
        // }
        if (item.apply === '' || needArr.indexOf(commType) >= 0) return true;
        for (let i = 0; i < detectType.length; i++) {
          if (needArr.indexOf(detectType[i]) >= 0) {
            return true;
          }
        }

        return false;
      }());

      if (need) {
        tasks.push(Object.assign({}, item, {
          status: 'default',
          text: `${item.name}中...`,
          success: `${item.name}完成`,
          error: `${item.name}失败`,
          execute: () => {
            // if (item.command.toLowerCase().indexOf('version cpu1') !== -1) {
            //   return RFBluetoothInstance.sendCommand(replaceCommand(item.command), item)
            //     .then((res) => {
            //       globalStore.version = res.split('=')[1];
            //       return res;
            //     });
            // }
            return RFBluetoothInstance.sendCommand(replaceCommand(item.command), item);
          }
        }));
      }
    });

    this.tasks = tasks;
    return Promise.resolve(this.tasks);
  }
}

export const automatorStore = new AutomatorStore();
